<script setup lang="ts">
import {
    IonList,
    IonLabel,
    IonIcon,
    IonTabs,
    IonItem,
    IonPage,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonContent,
    IonButtons,
    IonButton,
    IonTabBar,
    IonTabButton,
    IonItemGroup,
    IonItemDivider,
    IonBackButton,
} from "@ionic/vue";
import { timeOutline, playCircle } from "ionicons/icons";
</script>
<template>
    <ion-page>
        <ion-header>
            <ion-toolbar>
                <ion-buttons slot="start">
                    <ion-back-button default-href="/planning"></ion-back-button>
                </ion-buttons>
                <ion-title>Scadenze</ion-title>
            </ion-toolbar>
        </ion-header>
        <ion-content :fullscreen="true">
            <div>
                <ion-list>
                    <ion-item-group>
                        <ion-item-divider :sticky="true" class="ion-padding-vertical-half" style="padding-inline: 0">
                            <ion-title color="dark">CIAO</ion-title>
                        </ion-item-divider>
                        <ion-item v-for="i in 25" :key="i">
                            <ion-icon :icon="playCircle"></ion-icon>
                            <ion-label>Play</ion-label>
                        </ion-item>
                    </ion-item-group>
                </ion-list>
            </div>
        </ion-content>
    </ion-page>
</template>
